import { useCallback, useMemo } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { useACNavigate } from './useACNavigate';
const useSearchParams = () => {
  const navigate = useACNavigate();
  const location = useLocation();
  const setSearchParams = useCallback(params => {
    const newSearchParams = new URLSearchParams(location.search);
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') {
        newSearchParams.delete(key);
        return;
      }
      if (Array.isArray(value)) {
        newSearchParams.delete(key);
        value.forEach(v => newSearchParams.append(key, v));
      } else {
        newSearchParams.set(key, value);
      }
    });
    navigate(Object.assign({}, location, {
      search: `?${newSearchParams}`
    }), {
      replace: true
    });
  }, [navigate, location]);
  const searchParams = useMemo(() => {
    const result = {};
    const params = new URLSearchParams(location.search);
    for (const key of params.keys()) {
      var _allValues$;
      const allValues = params.getAll(key);
      result[key] = allValues.length > 1 ? allValues : (_allValues$ = allValues[0]) !== null && _allValues$ !== void 0 ? _allValues$ : undefined;
    }
    return result;
  }, [location.search]);
  return [searchParams, setSearchParams];
};
export default useSearchParams;